import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { onMounted, reactive, UnwrapRef } from "vue";
import { finishTask } from "@/api/home";
import { searchClinic } from "@/api/clinic";

import { useRoute } from "vue-router";
import { message } from "ant-design-vue";
import router from "@/router";
import { searchDentistTeam } from "@/api/dentist_team";
import { debounce } from 'lodash-es';

interface Options {
  clinics: any[],
  dentists: any[]
}

interface Item {
  clinicId: number | string,
  dentistId: number | string,
  dentistName: string,
  clinicName: string,
  loading: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 't109',
  setup(__props) {


const route = useRoute();


const state = reactive({
  data: [],
  value: [],
  fetching: false,
});

let item: UnwrapRef<Item> = reactive({
  dentistId: '',
  clinicId: '',
  dentistName: '',
  clinicName: '',
  loading: false
});

let options: UnwrapRef<Options> = reactive({
  clinics: [],
  dentists: []
});
let lastClinicId = 0;
const onSearchClinic = debounce((keyword: string) => {
  lastClinicId += 1;
  const fetchId = lastClinicId;
  state.fetching = true;
  options.clinics = []
  searchClinic({
    page: {
      pageSize: 100,
      currPage: 1,
    },
    keyword: keyword,
  }).then((res: any) => {
    if (fetchId !== lastClinicId) {
      // for fetch callback order
      return;
    }
    if (res.data) {
      res.data.forEach((r: any) => {
        options.clinics.push({
          value: r.id,
          label: r.firm.shortName,
        });
      });
      state.fetching = false;
    }
  });
}, 300)
let lastFetchId = 0;
const onSearchDentistTeam = debounce(value => {
  console.log('fetching user', value);
  lastFetchId += 1;
  const fetchId = lastFetchId;
  state.fetching = true;
  options.dentists = []
  searchDentistTeam({
    page: {
      pageSize: 1000,
      currPage: 1,
    },
    keyword: value
  }).then((res: any) => {
    console.log("keyword:", res.data)
    if (fetchId !== lastFetchId) {
      // for fetch callback order
      return;
    }
    if (res.data) {
      res.data.forEach((r: any) => {
        if (null != r.principal)
          options.dentists.push({
            value: r.principal.id,
            label: r.name,
          });
        state.fetching = false;
      });
    }
  });
}, 300);

const finishTask109 = () => {
  item.loading = true
  let processDefinitionId = route.query.processDefinitionId;
  let processInstanceId = route.query.processInstanceId;
  let processDefinitionKey = route.query.processDefinitionKey;
  let runTimeTaskId = route.query.runTimeTaskId;
  let taskCode = route.query.taskCode

  let parameters = {
    processDefinitionId: processDefinitionId,
    processInstanceId: processInstanceId,
    processDefinitionKey: processDefinitionKey,
    runTimeTaskId: runTimeTaskId,
    taskCode: taskCode,
    params: { dentistId: item.dentistId, clinicId: item.clinicId }
  };
  finishTask(parameters).then(() => {
    message.success("操作成功");
    item.loading = false
    router.push({
      path: "/home",
    });
  });


}

onMounted(() => {
  onSearchDentistTeam('')
  // onSearchClinic('')
})


return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "医生" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              style: {"width":"200px"},
              value: _unref(item).dentistId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(item).dentistId) = $event)),
              "show-search": "",
              placeholder: "请输入查询关键写",
              "filter-option": false,
              "not-found-content": state.fetching ? undefined : null,
              options: _unref(options).dentists,
              onSearch: _unref(onSearchDentistTeam),
              "default-active-first-option": false,
              "show-arrow": false
            }, _createSlots({ _: 2 }, [
              (state.fetching)
                ? {
                    name: "notFoundContent",
                    fn: _withCtx(() => [
                      _createVNode(_component_a_spin, { size: "small" })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["value", "not-found-content", "options", "onSearch"])
          ]),
          _: 1
        }),
        (_unref(item).dentistId)
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              "wrapper-col": { span: 6, offset: 0 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  style: {"width":"200px","margin-left":"42px"},
                  onClick: finishTask109,
                  loading: _unref(item).loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})